var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "图片适应模式" } },
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "请选择" },
              model: {
                value: _vm.activeData.config["imageFit"],
                callback: function ($$v) {
                  _vm.$set(_vm.activeData.config, "imageFit", $$v)
                },
                expression: "activeData.config['imageFit']",
              },
            },
            [
              _c("el-option", { attrs: { label: "填充", value: "fill" } }),
              _c("el-option", { attrs: { label: "包含", value: "contain" } }),
              _c("el-option", { attrs: { label: "覆盖", value: "cover" } }),
              _c("el-option", { attrs: { label: "原始", value: "none" } }),
              _c("el-option", {
                attrs: { label: "缩放", value: "scale-down" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "轮播时长" } },
        [
          _c("el-input", {
            staticStyle: { width: "40%" },
            attrs: { size: "small" },
            on: {
              input: function ($event) {
                return _vm.changeValue($event, _vm.activeData)
              },
            },
            model: {
              value: _vm.activeData.config["interval"],
              callback: function ($$v) {
                _vm.$set(_vm.activeData.config, "interval", $$v)
              },
              expression: "activeData.config['interval']",
            },
          }),
          _vm._v(" 秒 "),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "高度" } },
        [
          _c("el-input-number", {
            attrs: { label: "高度", min: 50, max: 10000, step: 5 },
            model: {
              value: _vm.activeData.config["height"],
              callback: function ($$v) {
                _vm.$set(_vm.activeData.config, "height", $$v)
              },
              expression: "activeData.config['height']",
            },
          }),
        ],
        1
      ),
      _c("el-divider", [_vm._v("选项")]),
      _c(
        "draggable",
        {
          attrs: {
            animation: 340,
            list: _vm.activeData.config.options,
            group: "selectItem",
            handle: ".option-drag",
          },
        },
        _vm._l(_vm.activeData.config.options, function (item, index) {
          return _c("div", { key: index, staticClass: "select-item" }, [
            _c("div", { staticClass: "select-line-icon option-drag" }, [
              _c("i", { staticClass: "el-icon-s-operation" }),
            ]),
            _c("div", { staticClass: "width-full" }, [
              _c(
                "div",
                { staticClass: "flex-row" },
                [
                  _c("el-input", {
                    attrs: { placeholder: "选项名", size: "small" },
                    model: {
                      value: item.label,
                      callback: function ($$v) {
                        _vm.$set(item, "label", $$v)
                      },
                      expression: "item.label",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "close-btn select-line-icon",
                      on: {
                        click: function ($event) {
                          return _vm.activeData.config.options.splice(index, 1)
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-remove-outline" })]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-row" },
                [
                  _c("el-input", {
                    attrs: { placeholder: "图片", size: "small" },
                    model: {
                      value: item.image,
                      callback: function ($$v) {
                        _vm.$set(item, "image", $$v)
                      },
                      expression: "item.image",
                    },
                  }),
                  _c(
                    "el-upload",
                    {
                      ref: "logoUpload",
                      refInFor: true,
                      staticStyle: { "text-align": "center" },
                      attrs: {
                        action: _vm.getUploadUrl,
                        headers: _vm.getUploadHeader,
                        "on-progress": _vm.uploadProgressHandle,
                        "on-success": function (response, file, fileList) {
                          item.image = response.data
                          _vm.$set(_vm.activeData.config.options, index, item)
                          _vm.closeUploadProgressHandle()
                        },
                        "show-file-list": false,
                        accept:
                          ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "select-line-icon",
                          attrs: { slot: "trigger" },
                          slot: "trigger",
                        },
                        [_c("i", { staticClass: "el-icon-upload" })]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ])
        }),
        0
      ),
      _c(
        "div",
        { staticStyle: { "margin-left": "20px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { "padding-bottom": "0" },
              attrs: { icon: "el-icon-circle-plus-outline", type: "text" },
              on: { click: _vm.addImageCarouselItem },
            },
            [_vm._v(" 添加选项 ")]
          ),
        ],
        1
      ),
      _c("el-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }